import { confirmDialog } from 'primereact/confirmdialog';
import { t } from 'i18next';
import { ReactNode } from 'react';

interface CustomDialogProps {
  header?: ReactNode;
  message?: ReactNode;
  defaultFocus?: string;
  rejectClassName?: string;
  acceptLabel?: string;
  rejectLabel?: string;
  accept: () => void;
  reject?: () => void;
}

export const showErrorDialog = ({ accept, reject }: CustomDialogProps) => {
  showCustomDialog({
    header: t('upgradePlanError'),
    message: t('upgradePlanErrorDesc'),
    acceptLabel: t('OK'),
    rejectClassName: 'hide',
    accept,
    reject,
  });
};

export const showCustomDialog = ({
  header = t('areYouSure'),
  message = t('areYouSureProceed'),
  rejectClassName = '',
  defaultFocus = 'accept',
  acceptLabel = t('yes'),
  rejectLabel = t('no'),
  accept,
  reject,
}: CustomDialogProps) => {
  confirmDialog({
    header,
    message,
    defaultFocus,
    rejectClassName,
    acceptLabel,
    rejectLabel,
    accept,
    reject,
  });
};
